import { PublicConfig } from './models';

export class StorePublicConfig {
  static readonly type = '[Public Config] Store Public Config';
  constructor(public publicConfig: PublicConfig, public surveyId: number) {}
}
